import React from 'react';
import { LogIn } from 'lucide-react';
import { useUser } from '../contexts/UserContext';

interface SignInWithTwitchButtonProps {
  returnTo?: string;
  className?: string;
  variant?: 'primary' | 'nav';
}

const SignInWithTwitchButton: React.FC<SignInWithTwitchButtonProps> = ({
  returnTo,
  className = '',
  variant = 'primary',
}) => {
  const { signInWithTwitch } = useUser();

  const baseClasses =
    variant === 'nav'
      ? 'flex items-center space-x-2 px-3 py-2 rounded-lg text-secondary-600 hover:text-secondary-900 hover:bg-secondary-100 dark:text-secondary-300 dark:hover:text-white dark:hover:bg-secondary-800 transition-colors duration-200'
      : 'inline-flex items-center justify-center space-x-2 bg-purple-600 text-white px-6 py-3 rounded-md hover:bg-purple-700 transition-colors font-medium';

  return (
    <button
      type="button"
      onClick={() => signInWithTwitch(returnTo)}
      className={`${baseClasses} ${className}`.trim()}
    >
      <LogIn className="h-4 w-4" />
      <span>Sign in with Twitch</span>
    </button>
  );
};

export default SignInWithTwitchButton;
